export interface IRegion {
  child: number[];
  code: string;
  name: string;
  center?: [number, number];
}
export const DRILL_TYPE_LIST = [
  'Country',
  'Region',
  'Province',
  'City',
  'County',
];
export const RegionList: { [key: string]: IRegion } = {
  '100': {
    name: '华北区',
    code: '100',
    child: [110000, 120000, 130000, 150000, 210000, 220000, 230000, 370000],
    center: [118.740234375, 42.87596410238256],
  },
  '101': {
    name: '华东区',
    code: '101',
    child: [320000, 340000, 310000],
    center: [118.564453125, 31.765537409484374],
  },
  '102': {
    name: '华南区',
    code: '102',
    child: [440000, 450000, 460000],
    center: [110.709228515625, 22.238259929564308],
  },
  '103': {
    name: '华西区',
    code: '103',
    child: [500000, 510000, 520000, 530000],
    center: [90.263671875, 36.73888412439431],
  },
  '104': {
    name: '华中区',
    code: '104',
    child: [330000, 350000, 360000, 420000, 430000],
    center: [118.05908203124999, 28.38173504322308],
  },
  '301': {
    name: '中西区',
    code: '301',
    child: [140000, 410000, 540000, 610000, 620000, 630000, 640000, 650000],
    center: [109.1162109375, 35.209721645221386],
  },
  '701': {
    name: '港澳台',
    code: '701',
    child: [710000, 810000, 820000],
  },
};
